<template>
  <div>
    <b-row>
      <b-col />
      <b-col>
        <b-img src="../assets/logo.png" alt="Hoops Yard" height="180"></b-img>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <ul class="mt-2 list-unstyled">
          <li> <strong>Whatsapp:</strong><a href="https://wa.me/+50763084298" target="_blank" title="Hoopsyard en Whatsapp">+50763084298</a></li>
          <li><strong>Instagram:</strong> <a href="https://www.instagram.com/hoopsyard/" target="_blank" title="Hoopsyard en Instagram">@hoopsyard</a></li>
        </ul>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-img src="../assets/courts.jpg" fluid alt="Hoops Yard"></b-img>
      </b-col>
      <b-col>
        <p>
          Hoops Yard, es un nuevo centro deportivo de tres canchas de basketball, gimnasio de pesas, amplio estacionamiento, duchas, y valores agregados como Food Trucks, Nutrition Bar, etc.
          <br />Ofrecemos un ambiente familiar deportivo (Vóleibol y Basketball) para que puedan compartir después de un día laboral.
        </p>
        <p>Organizamos:</p>
        <ul>
          <li>Ligas empresariales internas masculino, femenino, mixto</li>
          <li>Ligas interempresariales masculino, femenino, mixto</li>
          <li>Torneos de un día</li>
          <li>Cuadrangulares</li>
          <li>Alquiler de canchas por hora para grupos privados</li>
          <li>Eventos deportivos en general</li>
        </ul>
        <p>Estamos ubicados en Juan Díaz, diagonal al Crown Casinos del Hipódromo, Parque Logístico Metropolitano.</p>
      </b-col>
      <b-col>
        <p><b-img src="../assets/map.png" fluid alt="Hoops Yard"></b-img></p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
}
</script>
<style>
.es { color: #13317b; }
</style>
